import { render } from "./EmployeeContactDetails.vue?vue&type=template&id=1759c096"
import script from "./EmployeeContactDetails.vue?vue&type=script&lang=js"
export * from "./EmployeeContactDetails.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/AIF_Orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__